import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { createElement } from 'react';
import Box from '../../Box/index.esm.js';
import TextInput from '../../TextInput/index.esm.js';

function Input(props) {
  var max = props.max,
      step = props.step;
  var charLength = (max + step).toString().length;
  return createElement(Box, null, createElement(TextInput, _extends({}, props, {
    style: {
      width: "calc(" + charLength * 9 + "px + 2.5rem)"
    }
  })));
}

export default Input;
//# sourceMappingURL=index.esm.js.map
